import React from "react";
import constant from "../utils/mapconstants";
import DrawSytles from "./DrawStyles";
import TrimbleMapsDrawControl from "@trimblemaps/trimblemaps-draw";
import { withMapContext } from "./MapContext";

class DrawTool extends React.Component {
  draw = null;

  componentDidMount() {
    this.draw = new TrimbleMapsDrawControl({
      boxSelect: true,
      displayControlsDefault: false,
      styles:DrawSytles()
    });

    this.props.map.addControl(this.draw, "top-left");
    this.setDrawObject();
  }

  setDrawObject = () => {
    this.props.eventHub &&
      this.props.eventHub.emit(constant.EVENT.SET_MAP_DRAW, {
        map: this.props.map,
        draw: this.draw,
        drawComplete: this.props.onDrawingComplete,
      });
  };

  shouldComponentUpdate(nextProps) {
    this.setDrawObject();
    return false;
  }

  render() {
    return null;
  }
}

export default withMapContext(DrawTool);
